import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function UserRegesterModal({ handleClose, show }) {

  const Navigate = useNavigate();

  // const navigate = useNavigate();
  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>⭕ Login Is Needed</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please Login To Like & Download Files You Desire</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => Navigate('/login')}>👉 Login Now</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
